
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","viewBox":"0 0 19 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M16.944 0c.654 1.08.95 2.194.95 3.6 0 4.484-3.83 10.31-6.937 14.4H3.859L1.013.982l6.214-.59 1.505 12.11c1.407-2.291 3.142-5.89 3.142-8.345 0-1.343-.23-2.258-.59-3.012L16.944 0z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M16.944 0c.654 1.08.95 2.194.95 3.6 0 4.484-3.83 10.31-6.937 14.4H3.859L1.013.982l6.214-.59 1.505 12.11c1.407-2.291 3.142-5.89 3.142-8.345 0-1.343-.23-2.258-.59-3.012L16.944 0z"}})])
          )
        }
      }
    